// Font sizes and line heights of the Figma "Responsive" collection (S mobile, L from md), inlined until the design
// system carries the sizes of the subflow mockup
export const h2Text =
  'text-[24px] leading-[30px] md:text-[28px] md:leading-[34px]'
export const h4Text =
  'text-[18px] leading-[24px] md:text-[20px] md:leading-[30px]'
export const p1Text =
  'text-[16px] leading-[22px] md:text-[20px] md:leading-[30px]'
export const p2Text =
  'text-[14px] leading-[20px] md:text-[18px] md:leading-[28px]'
export const p3Text =
  'text-[13px] leading-[18px] md:text-[16px] md:leading-[20px]'
export const p4Text =
  'text-[12px] leading-[16px] md:text-[15px] md:leading-[20px]'
